import React, { useState } from "react"
import { Card, CardBody, Collapse, Table } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import ProvinceConsumptionReporFilter from "./filter"
import PaginationLinks from "components/Pagination"

const ProvinceConsumptionReportListComponent = ({
  data,
  error,
  loading,
  onChangeOrdering,
  onExportBtnClick,
  onSearchHandler,
  exportStatus,
  onChangeRowNumber,
  onPageClick,
  columns,
  visibleColumns,
  onToggleColumn,
  onReorder,
}) => {
  const [filterOpen, setFilterOpen] = useState(false)

  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  const onAdvancedSearchSubmit = searchData => {
    onSearchHandler(searchData)
  }

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          onChangeRowNumber={onChangeRowNumber}
          title={"CONSUMPTION REPORTS"}
          lgColumn={6}
          exportBtn={true}
          exportBtnLoading={exportStatus?.loading}
          onExportBtnClick={onExportBtnClick}
          rowCount={true}
          orderingList={true}
          onChangeOrdering={onChangeOrdering}
          searchBox={false}
          rightBtn={false}
          advnacedSearchBtn={true}
          advnacedSearchBtnTitle={"Filter"}
          onAdvancedSearch={onAdvancedSearchHandler}
          orderingOptions={[{ value: "date", name: "Date" }]}
        />
        <Collapse isOpen={filterOpen}>
          <ProvinceConsumptionReporFilter
            loading={loading}
            error={error}
            onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            columns={columns}
            onToggleColumn={onToggleColumn}
            onReorder={onReorder}
          />
        </Collapse>

        <div className="table-responsive">
          <Table className="table mb-0">
            <thead>
              <tr>
                {visibleColumns.map(column => (
                  <th key={column.key} style={column.style}>
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.data?.map((row, index) => (
                <tr key={index}>
                  {visibleColumns.map(column => (
                    <td key={column.key} style={column.style}>
                      {column.render(row, index)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
          {data?.meta && (
            <PaginationLinks meta={data?.meta} onPageClick={onPageClick} />
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default ProvinceConsumptionReportListComponent
